import moment from 'moment';

export function getTimeAgo(time) {
    const date = time ? Number(time) : undefined;
    let string = '';
    if (time) {
        const diffDay = moment().diff(moment(date), 'day');
        if (diffDay > 3) {
            string = moment(date).format('DD/MM/YYYY');
        } else if (diffDay > 0) {
            string = `${diffDay} days ago`;
        } else {
            const diffHour = moment().diff(moment(date), 'hour');
            if (diffHour > 0) {
                string = `${diffHour} hours ago`;
            } else {
                const diffMinute = moment().diff(moment(date), 'minute');
                if (diffMinute > 0) {
                    string = `${diffMinute} minutes ago`;
                } else {
                    string = 'A few seconds ago';
                }
            }
        }
    }
    return string;
}
